import { css, keyframes } from '@emotion/css';
import { useTranslation } from 'react-i18next';

interface Props {
  sizeInPx?: number;
}

export const LoadingSpinner = ({ sizeInPx }: Props) => {
  const { t } = useTranslation();
  return (
    <div
      aria-label={t('loading')}
      className={spinner({ size: sizeInPx ?? 150 })}
    />
  );
};

const spin = keyframes`
    0% {
        -webkit-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        transform: rotate(360deg);
    }
`;

const spinner = ({ size }: { size: number }) => css`
  position: relative;
  width: ${size}px;
  height: ${size}px;
  border-radius: 50%;
  border: ${size / 50}px solid transparent;
  border-top-color: #21376f;
  -webkit-animation: spin 2s linear infinite;
  animation: ${spin} 2s linear infinite;
  &:before {
    content: '';
    position: absolute;
    top: ${size / 30}px;
    left: ${size / 30}px;
    right: ${size / 30}px;
    bottom: ${size / 30}px;
    border-radius: 50%;
    border: ${size / 50}px solid transparent;
    border-top-color: #2f4858;
    -webkit-animation: spin 3s linear infinite;
    animation: ${spin} 3s linear infinite;
  }
  &:after {
    content: '';
    position: absolute;
    top: ${size / 10}px;
    left: ${size / 10}px;
    right: ${size / 10}px;
    bottom: ${size / 10}px;
    border-radius: 50%;
    border: ${size / 50}px solid transparent;
    border-top-color: #000;
    -webkit-animation: spin 1.5s linear infinite;
    animation: ${spin} 1.5s linear infinite;
  }
`;
